// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qnyS","buttons":"Footer_buttons__2H8ET"};